export const DEFAULT_PLACEHOLDER = 'fieldTypes.enterPlaceholder'
